import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, Pipe, ViewContainerRef, ViewEncapsulation, ViewChild, NgModule } from '@angular/core';
import * as i2 from '@angular/forms';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@capturum/ui/button';
import { CapturumButtonModule } from '@capturum/ui/button';
import * as i3 from '@ngx-formly/core';
import { FieldType, FieldWrapper, FormlyModule } from '@ngx-formly/core';
import * as i1$1 from '@capturum/ui/dropdown';
import { CapturumDropdownModule } from '@capturum/ui/dropdown';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i1$2 from '@capturum/ui/select-button';
import { CapturumSelectButtonModule } from '@capturum/ui/select-button';
import * as i1$3 from '@capturum/ui/multi-select';
import { CapturumMultiSelectModule } from '@capturum/ui/multi-select';
import * as i1$4 from '@capturum/ui/input';
import { CapturumInputModule } from '@capturum/ui/input';
import * as i1$5 from '@capturum/ui/checkbox';
import { CapturumCheckboxModule } from '@capturum/ui/checkbox';
import * as i1$6 from '@capturum/ui/calendar';
import { CapturumCalendarModule } from '@capturum/ui/calendar';
import * as i1$7 from '@capturum/ui/chips';
import { CapturumChipsModule } from '@capturum/ui/chips';
import * as i1$8 from '@capturum/ui/input-switch';
import { CapturumInputSwitchModule } from '@capturum/ui/input-switch';
import * as i1$9 from '@capturum/ui/color-picker';
import { CapturumColorPickerModule } from '@capturum/ui/color-picker';
import * as i1$a from '@capturum/ui/textarea';
import { CapturumTextareaModule } from '@capturum/ui/textarea';
import * as i2$1 from '@capturum/ui/autocomplete';
import { CapturumAutocompleteModule } from '@capturum/ui/autocomplete';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CapturumSharedModule } from '@capturum/ui/api';
const _c0 = ["fieldComponent"];
function FormFieldWrapper_label_1_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormFieldWrapper_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 5);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "observablePipe");
    i0.ɵɵtemplate(4, FormFieldWrapper_label_1_span_4_Template, 2, 0, "span", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵattribute("for", ctx_r0.id);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 3, i0.ɵɵpipeBind1(3, 5, ctx_r0.to.translateLabel)), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.to.required && ctx_r0.to.hideRequiredMarker !== true);
  }
}
function FormFieldWrapper_ng_template_2_Template(rf, ctx) {}
function FormFieldWrapper_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "formly-validation-message", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("display", "block");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("field", ctx_r3.field);
  }
}
function FormFieldWrapper_small_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 9);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "observablePipe");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, i0.ɵɵpipeBind1(3, 3, ctx_r4.to.description)));
  }
}
function ImageTypeComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "img", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵclassMap(ctx_r0.to.previewImageClass);
    i0.ɵɵproperty("src", ctx_r0.formControl.value, i0.ɵɵsanitizeUrl);
  }
}
function ImageTypeComponent_label_1_i_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r2.to.iconClass || "fa fa-upload");
  }
}
function ImageTypeComponent_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 6);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "observablePipe");
    i0.ɵɵtemplate(4, ImageTypeComponent_label_1_i_4_Template, 1, 2, "i", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.to.buttonClass || "btn btn-primary");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 4, i0.ɵɵpipeBind1(3, 6, ctx_r1.to.translatePlaceholder || ctx_r1.to.placeholder)) || "Upload", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.to.showIcon);
  }
}
function AutocompleteDropdownComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "cap-autocomplete", 1);
    i0.ɵɵlistener("onSelect", function AutocompleteDropdownComponent_ng_container_0_Template_cap_autocomplete_onSelect_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.to.change ? ctx_r2.to.change(ctx_r2.field, $event) : null);
    })("completeMethod", function AutocompleteDropdownComponent_ng_container_0_Template_cap_autocomplete_completeMethod_1_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r3);
      const options_r1 = restoredCtx.ngIf;
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.filterResults($event, options_r1));
    });
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "observablePipe");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "observablePipe");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵpipe(7, "observablePipe");
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "observablePipe");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("suggestionsFilter", ctx_r0.filteredResults)("formControl", ctx_r0.formControl)("formlyAttributes", ctx_r0.field)("field", ctx_r0.to.additionalProperties && ctx_r0.to.additionalProperties["filterField"] ? ctx_r0.to.additionalProperties["filterField"] : "label")("emptyMessage", i0.ɵɵpipeBind1(2, 9, i0.ɵɵpipeBind1(3, 11, ctx_r0.to.additionalProperties["emptyMessage"] || "No results")))("placeholder", i0.ɵɵpipeBind1(4, 13, i0.ɵɵpipeBind1(5, 15, ctx_r0.to.translatePlaceholder || ctx_r0.to.placeholder)))("dropdown", true)("floatLabel", i0.ɵɵpipeBind1(6, 17, i0.ɵɵpipeBind1(7, 19, ctx_r0.to.label_position)) === "floating")("label", i0.ɵɵpipeBind1(8, 21, i0.ɵɵpipeBind1(9, 23, ctx_r0.to.label_position)) === "floating" ? ctx_r0.to.label : "");
  }
}
let FormService = /*#__PURE__*/(() => {
  class FormService {
    constructor() {}
    static {
      this.ɵfac = function FormService_Factory(t) {
        return new (t || FormService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FormService,
        factory: FormService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FormService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Used for Form component
 */
class FormField {
  constructor(data) {
    // Set values
    this.key = data['key'];
    this.id = data['key'];
    this.type = data['type'] || 'input';
    this.className = data['className'] || null;
    this.wrappers = data['wrappers'] || ['cap-form-field'];
    let props = {};
    if (data['props']) {
      props = data['props'];
      props['label'] = data['props']['label'] || data['key'];
      props['placeholder'] = data['props']['placeholder'] || `${props['label']}...`;
      props['required'] = data['props']['required'] || true;
      props['options'] = data['props']['options'] || true;
    }
    this.props = props;
  }
}
let FormComponent = /*#__PURE__*/(() => {
  class FormComponent {
    get fields() {
      return this._fields;
    }
    set fields(fields) {
      const setFields = [];
      fields.forEach(field => {
        setFields.push(new FormField(field));
      });
      this._fields = setFields;
    }
    constructor() {
      this.onSubmit = new EventEmitter();
      this.form = new FormGroup({});
      this.model = {
        email: 'email@gmail.com'
      };
    }
    submit(model) {
      this.onSubmit.emit(model);
    }
    static {
      this.ɵfac = function FormComponent_Factory(t) {
        return new (t || FormComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormComponent,
        selectors: [["em-form"]],
        inputs: {
          fields: "fields",
          model: "model"
        },
        outputs: {
          onSubmit: "onSubmit"
        },
        decls: 3,
        vars: 4,
        consts: [[3, "formGroup", "ngSubmit"], [3, "form", "fields", "model"], ["type", "submit", "label", "Submit"]],
        template: function FormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0);
            i0.ɵɵlistener("ngSubmit", function FormComponent_Template_form_ngSubmit_0_listener() {
              return ctx.submit(ctx.model);
            });
            i0.ɵɵelementStart(1, "formly-form", 1);
            i0.ɵɵelement(2, "cap-button", 2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("form", ctx.form)("fields", ctx.fields)("model", ctx.model);
          }
        },
        dependencies: [i1.CapturumButtonComponent, i2.ɵNgNoValidate, i2.NgControlStatusGroup, i2.FormGroupDirective, i3.FormlyForm],
        encapsulation: 2
      });
    }
  }
  return FormComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormlySelectOptionsPipe = /*#__PURE__*/(() => {
  class FormlySelectOptionsPipe {
    transform(options, field) {
      if (!(options instanceof Observable)) {
        options = of(options);
      }
      return options.pipe(map(value => this.toOptions(value, field || {})));
    }
    toOptions(options, field) {
      const gOptions = [],
        groups = {},
        to = field.props || {};
      options.map(option => {
        if (!this.getGroupProp(option, to)) {
          gOptions.push(this.toOption(option, to));
        } else {
          if (!groups[this.getGroupProp(option, to)]) {
            groups[this.getGroupProp(option, to)] = [];
            gOptions.push({
              label: this.getGroupProp(option, to),
              group: groups[this.getGroupProp(option, to)]
            });
          }
          groups[this.getGroupProp(option, to)].push(this.toOption(option, to));
        }
      });
      return gOptions;
    }
    toOption(item, to) {
      return {
        label: this.getLabelProp(item, to),
        value: this.getValueProp(item, to),
        disabled: this.getDisabledProp(item, to) || false
      };
    }
    getLabelProp(item, to) {
      if (typeof to.labelProp === 'function') {
        return to.labelProp(item);
      }
      if (this.shouldUseLegacyOption(item, to)) {
        return item.value;
      }
      return item[to.labelProp || 'label'];
    }
    getValueProp(item, to) {
      if (typeof to.valueProp === 'function') {
        return to.valueProp(item);
      }
      if (this.shouldUseLegacyOption(item, to)) {
        return item.key;
      }
      return item[to.valueProp || 'value'];
    }
    getDisabledProp(item, to) {
      if (typeof to.disabledProp === 'function') {
        return to.disabledProp(item);
      }
      return item[to.disabledProp || 'disabled'];
    }
    getGroupProp(item, to) {
      if (typeof to.groupProp === 'function') {
        return to.groupProp(item);
      }
      return item[to.groupProp || 'group'];
    }
    shouldUseLegacyOption(item, to) {
      return !to.valueProp && !to.labelProp && item != null && typeof item === 'object' && 'key' in item && 'value' in item;
    }
    static {
      this.ɵfac = function FormlySelectOptionsPipe_Factory(t) {
        return new (t || FormlySelectOptionsPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "formlySelectOptions",
        type: FormlySelectOptionsPipe,
        pure: true
      });
    }
  }
  return FormlySelectOptionsPipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Transform a string|number to an Observable
 */
let ObservablePipe = /*#__PURE__*/(() => {
  class ObservablePipe {
    transform(value, args) {
      if (!(value instanceof Observable)) {
        return of(value);
      }
      return value;
    }
    static {
      this.ɵfac = function ObservablePipe_Factory(t) {
        return new (t || ObservablePipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "observablePipe",
        type: ObservablePipe,
        pure: true
      });
    }
  }
  return ObservablePipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DropdownTypeComponent = /*#__PURE__*/(() => {
  class DropdownTypeComponent extends FieldType {
    constructor() {
      super(...arguments);
      this.defaultOptions = {
        props: {
          sortAlphabetically: true,
          sortBy: 'label',
          filterBy: 'label',
          filter: true,
          virtualScroll: true,
          showClear: false,
          virtualScrollItemSize: 30,
          emptyFilterMessage: 'No results found',
          scrollHeight: '200px',
          name: '',
          inputId: '',
          selectId: '',
          dataKey: '',
          style: null,
          panelStyle: null,
          styleClass: '',
          panelStyleClass: '',
          editable: false,
          autofocus: false,
          resetFilterOnHide: false,
          dropdownIcon: 'pi pi-chevron-down',
          optionLabel: '',
          autoDisplayFirst: true,
          group: false,
          ariaFilterLabel: '',
          withImages: false,
          openOnFocus: false,
          hasTooltip: false,
          optionValue: 'value',
          autofocusFilter: true
        }
      };
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵDropdownTypeComponent_BaseFactory;
        return function DropdownTypeComponent_Factory(t) {
          return (ɵDropdownTypeComponent_BaseFactory || (ɵDropdownTypeComponent_BaseFactory = i0.ɵɵgetInheritedFactory(DropdownTypeComponent)))(t || DropdownTypeComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DropdownTypeComponent,
        selectors: [["em-formly-dropdown"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 11,
        vars: 61,
        consts: [[3, "options", "formlyAttributes", "formControl", "placeholder", "filterPlaceholder", "floatLabel", "label", "panelStyle", "styleClass", "panelStyleClass", "sortAlphabetically", "sortBy", "filterBy", "emptyFilterMessage", "scrollHeight", "name", "inputId", "selectId", "dataKey", "readonly", "autofocus", "resetFilterOnHide", "dropdownIcon", "optionLabel", "autoDisplayFirst", "showClear", "group", "optionValue", "ariaFilterLabel", "withImages", "openOnFocus", "hasTooltip", "editable", "virtualScroll", "filter", "appendTo", "autofocusFilter", "virtualScrollItemSize"]],
        template: function DropdownTypeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cap-dropdown", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "formlySelectOptions");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵpipe(4, "observablePipe");
            i0.ɵɵpipe(5, "async");
            i0.ɵɵpipe(6, "observablePipe");
            i0.ɵɵpipe(7, "async");
            i0.ɵɵpipe(8, "observablePipe");
            i0.ɵɵpipe(9, "async");
            i0.ɵɵpipe(10, "observablePipe");
          }
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.to.style);
            i0.ɵɵproperty("options", i0.ɵɵpipeBind1(1, 40, i0.ɵɵpipeBind2(2, 42, ctx.to.options, ctx.field)))("formlyAttributes", ctx.field)("formControl", ctx.formControl)("placeholder", i0.ɵɵpipeBind1(3, 45, i0.ɵɵpipeBind1(4, 47, ctx.to.translatePlaceholder || ctx.to.placeholder)))("filterPlaceholder", i0.ɵɵpipeBind1(5, 49, i0.ɵɵpipeBind1(6, 51, ctx.to.filterPlaceholder || ctx.to.placeholder)))("floatLabel", i0.ɵɵpipeBind1(7, 53, i0.ɵɵpipeBind1(8, 55, ctx.to.label_position)) === "floating")("label", i0.ɵɵpipeBind1(9, 57, i0.ɵɵpipeBind1(10, 59, ctx.to.label_position)) === "floating" ? ctx.to.label : "")("panelStyle", ctx.to.panelStyle)("styleClass", ctx.to.styleClass)("panelStyleClass", ctx.to.panelStyleClass)("sortAlphabetically", ctx.to.sortAlphabetically)("sortBy", ctx.to.sortBy)("filterBy", ctx.to.filterBy)("emptyFilterMessage", ctx.to.emptyFilterMessage)("scrollHeight", ctx.to.scrollHeight)("name", ctx.to.name)("inputId", ctx.to.inputId)("selectId", ctx.to.selectId)("dataKey", ctx.to.dataKey)("readonly", ctx.to.readonly)("autofocus", ctx.to.autofocus)("resetFilterOnHide", ctx.to.resetFilterOnHide)("dropdownIcon", ctx.to.dropdownIcon)("optionLabel", ctx.to.optionLabel)("autoDisplayFirst", ctx.to.autoDisplayFirst)("showClear", ctx.to.showClear)("group", ctx.to.group)("optionValue", ctx.to.optionValue)("ariaFilterLabel", ctx.to.ariaFilterLabel)("withImages", ctx.to.withImages)("openOnFocus", ctx.to.openOnFocus)("hasTooltip", ctx.to.hasTooltip)("editable", ctx.to.editable)("virtualScroll", ctx.to.virtualScroll || ctx.defaultOptions.props.virtualScroll)("filter", ctx.to.filter || ctx.defaultOptions.props.filter)("appendTo", ctx.to.appendTo)("autofocusFilter", ctx.to.autofocusFilter)("virtualScrollItemSize", ctx.to.virtualScrollItemSize || ctx.defaultOptions.props.virtualScrollItemSize);
          }
        },
        dependencies: [i1$1.CapturumDropdownComponent, i2.NgControlStatus, i2.FormControlDirective, i3.ɵFormlyAttributes, i4.AsyncPipe, FormlySelectOptionsPipe, ObservablePipe],
        encapsulation: 2
      });
    }
  }
  return DropdownTypeComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SelectButtonTypeComponent = /*#__PURE__*/(() => {
  class SelectButtonTypeComponent extends FieldType {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵSelectButtonTypeComponent_BaseFactory;
        return function SelectButtonTypeComponent_Factory(t) {
          return (ɵSelectButtonTypeComponent_BaseFactory || (ɵSelectButtonTypeComponent_BaseFactory = i0.ɵɵgetInheritedFactory(SelectButtonTypeComponent)))(t || SelectButtonTypeComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SelectButtonTypeComponent,
        selectors: [["em-select-button-formly"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 9,
        consts: [[3, "formControl", "optionLabel", "dataKey", "formlyAttributes", "options"]],
        template: function SelectButtonTypeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cap-select-button", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "observablePipe");
          }
          if (rf & 2) {
            i0.ɵɵproperty("formControl", ctx.formControl)("optionLabel", ctx.field.props.optionLabel ? ctx.field.props.optionLabel : "label")("dataKey", ctx.field.props.dataKey ? ctx.field.props.dataKey : "value")("formlyAttributes", ctx.field)("options", i0.ɵɵpipeBind1(1, 5, i0.ɵɵpipeBind1(2, 7, ctx.field.props.options)));
          }
        },
        dependencies: [i1$2.CapturumSelectButtonComponent, i2.NgControlStatus, i2.FormControlDirective, i3.ɵFormlyAttributes, i4.AsyncPipe, ObservablePipe],
        encapsulation: 2
      });
    }
  }
  return SelectButtonTypeComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MultiSelectTypeComponent = /*#__PURE__*/(() => {
  class MultiSelectTypeComponent extends FieldType {
    constructor() {
      super(...arguments);
      this.defaultOptions = {
        props: {
          filter: true,
          filterBy: 'label',
          appendTo: null,
          scrollHeight: '200px',
          overlayVisible: false,
          dataKey: 'value',
          defaultLabel: 'Choose',
          onChange: null,
          autofocusFilter: true
        }
      };
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵMultiSelectTypeComponent_BaseFactory;
        return function MultiSelectTypeComponent_Factory(t) {
          return (ɵMultiSelectTypeComponent_BaseFactory || (ɵMultiSelectTypeComponent_BaseFactory = i0.ɵɵgetInheritedFactory(MultiSelectTypeComponent)))(t || MultiSelectTypeComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MultiSelectTypeComponent,
        selectors: [["em-multi-select-type"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 9,
        vars: 33,
        consts: [[3, "options", "formlyAttributes", "formControl", "defaultLabel", "disabled", "styleClass", "inputId", "filter", "filterBy", "filterPlaceHolder", "appendTo", "autofocusFilter", "scrollHeight", "readonly", "floatLabel", "label", "onChange"]],
        template: function MultiSelectTypeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-multi-select", 0);
            i0.ɵɵlistener("onChange", function MultiSelectTypeComponent_Template_cap_multi_select_onChange_0_listener($event) {
              return ctx.to.change ? ctx.to.change(ctx.field, $event) : null;
            });
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "formlySelectOptions");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵpipe(4, "observablePipe");
            i0.ɵɵpipe(5, "async");
            i0.ɵɵpipe(6, "observablePipe");
            i0.ɵɵpipe(7, "async");
            i0.ɵɵpipe(8, "observablePipe");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("options", i0.ɵɵpipeBind1(1, 16, i0.ɵɵpipeBind2(2, 18, ctx.to.options, ctx.field)))("formlyAttributes", ctx.field)("formControl", ctx.formControl)("defaultLabel", i0.ɵɵpipeBind1(3, 21, i0.ɵɵpipeBind1(4, 23, ctx.to.translatePlaceholder || ctx.to.placeholder)))("disabled", ctx.to.disabled)("styleClass", ctx.to.styleClass)("inputId", ctx.field.key)("filter", ctx.to.filter || ctx.defaultOptions.props.filter)("filterBy", ctx.to.filterBy || ctx.defaultOptions.props.filterBy)("filterPlaceHolder", ctx.to.filterPlaceHolder)("appendTo", ctx.to.appendTo)("autofocusFilter", ctx.to.autofocusFilter)("scrollHeight", ctx.to.scrollHeight || ctx.defaultOptions.props.scrollHeight)("readonly", ctx.to.readOnly)("floatLabel", i0.ɵɵpipeBind1(5, 25, i0.ɵɵpipeBind1(6, 27, ctx.to.label_position)) === "floating")("label", i0.ɵɵpipeBind1(7, 29, i0.ɵɵpipeBind1(8, 31, ctx.to.label_position)) === "floating" ? ctx.to.label : "");
          }
        },
        dependencies: [i1$3.CapturumMultiSelectComponent, i2.NgControlStatus, i2.FormControlDirective, i3.ɵFormlyAttributes, i4.AsyncPipe, FormlySelectOptionsPipe, ObservablePipe],
        encapsulation: 2
      });
    }
  }
  return MultiSelectTypeComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputTypeComponent = /*#__PURE__*/(() => {
  class InputTypeComponent extends FieldType {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵInputTypeComponent_BaseFactory;
        return function InputTypeComponent_Factory(t) {
          return (ɵInputTypeComponent_BaseFactory || (ɵInputTypeComponent_BaseFactory = i0.ɵɵgetInheritedFactory(InputTypeComponent)))(t || InputTypeComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputTypeComponent,
        selectors: [["em-input-formly"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 23,
        consts: [[3, "type", "placeholder", "formlyAttributes", "autocomplete", "formControl", "floatLabel", "label"]],
        template: function InputTypeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cap-input", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "observablePipe");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵpipe(4, "observablePipe");
            i0.ɵɵpipe(5, "async");
            i0.ɵɵpipe(6, "observablePipe");
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.to.styleClass);
            i0.ɵɵclassProp("ng-dirty", ctx.showError);
            i0.ɵɵproperty("type", ctx.to.type || "text")("placeholder", i0.ɵɵpipeBind1(1, 11, i0.ɵɵpipeBind1(2, 13, ctx.to.translatePlaceholder || ctx.to.placeholder)))("formlyAttributes", ctx.field)("autocomplete", ctx.to.autocomplete || "off")("formControl", ctx.formControl)("floatLabel", i0.ɵɵpipeBind1(3, 15, i0.ɵɵpipeBind1(4, 17, ctx.to.label_position)) === "floating")("label", i0.ɵɵpipeBind1(5, 19, i0.ɵɵpipeBind1(6, 21, ctx.to.label_position)) === "floating" ? ctx.to.label : "");
          }
        },
        dependencies: [i1$4.CapturumInputComponent, i2.NgControlStatus, i2.FormControlDirective, i3.ɵFormlyAttributes, i4.AsyncPipe, ObservablePipe],
        encapsulation: 2
      });
    }
  }
  return InputTypeComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CheckboxTypeComponent = /*#__PURE__*/(() => {
  class CheckboxTypeComponent extends FieldType {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCheckboxTypeComponent_BaseFactory;
        return function CheckboxTypeComponent_Factory(t) {
          return (ɵCheckboxTypeComponent_BaseFactory || (ɵCheckboxTypeComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CheckboxTypeComponent)))(t || CheckboxTypeComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckboxTypeComponent,
        selectors: [["lib-checkbox-formly"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 6,
        consts: [["binary", "true", 3, "formControl", "formlyAttributes", "tabIndex", "styleClass", "onChange"]],
        template: function CheckboxTypeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-checkbox", 0);
            i0.ɵɵlistener("onChange", function CheckboxTypeComponent_Template_cap_checkbox_onChange_0_listener($event) {
              return ctx.to.onChange ? ctx.to.onChange($event) : null;
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.to.style || null);
            i0.ɵɵproperty("formControl", ctx.formControl)("formlyAttributes", ctx.field)("tabIndex", ctx.to.tabindex || null)("styleClass", ctx.to.styleClass || null);
          }
        },
        dependencies: [i1$5.CapturumCheckboxComponent, i2.NgControlStatus, i2.FormControlDirective, i3.ɵFormlyAttributes],
        encapsulation: 2
      });
    }
  }
  return CheckboxTypeComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CalendarTypeComponent = /*#__PURE__*/(() => {
  class CalendarTypeComponent extends FieldType {
    constructor() {
      super(...arguments);
      this.defaultLocale = {
        firstDayOfWeek: 0,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        today: 'Today',
        clear: 'Clear',
        dateFormat: 'mm/dd/yy',
        weekHeader: 'Wk'
      };
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCalendarTypeComponent_BaseFactory;
        return function CalendarTypeComponent_Factory(t) {
          return (ɵCalendarTypeComponent_BaseFactory || (ɵCalendarTypeComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CalendarTypeComponent)))(t || CalendarTypeComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CalendarTypeComponent,
        selectors: [["em-formly-calendar"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 66,
        consts: [[3, "formlyAttributes", "formControl", "floatLabel", "label", "defaultDate", "selectionMode", "inputStyle", "inputId", "name", "placeholder", "disabled", "dateFormat", "inline", "showOtherMonths", "selectOtherMonths", "showIcon", "showOnFocus", "icon", "appendTo", "readonlyInput", "shortYearCutoff", "minDate", "maxDate", "disabledDates", "disabledDays", "monthNavigator", "yearNavigator", "yearRange", "showTime", "hourFormat", "timeOnly", "dataType", "required", "tabIndex", "showSeconds", "stepHour", "stepMinute", "stepSecond", "maxDateCount", "showButtonBar", "todayButtonStyleClass", "clearButtonStyleClass", "panelStyleClass", "panelStyle", "keepInvalid", "hideOnDateTimeSelect", "numberOfMonths", "view", "touchUI", "showTransitionOptions", "hideTransitionOptions", "inputStyleClass", "onSelect", "onBlur", "onFocus", "onClose", "onInput", "onTodayClick", "onClearClick", "onMonthChange", "onYearChange"]],
        template: function CalendarTypeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-calendar", 0);
            i0.ɵɵlistener("onSelect", function CalendarTypeComponent_Template_cap_calendar_onSelect_0_listener($event) {
              return ctx.to.onSelect ? ctx.to.onSelect($event) : null;
            })("onBlur", function CalendarTypeComponent_Template_cap_calendar_onBlur_0_listener($event) {
              return ctx.to.onBlur ? ctx.to.onBlur($event) : null;
            })("onFocus", function CalendarTypeComponent_Template_cap_calendar_onFocus_0_listener($event) {
              return ctx.to.onFocus ? ctx.to.onFocus($event) : null;
            })("onClose", function CalendarTypeComponent_Template_cap_calendar_onClose_0_listener($event) {
              return ctx.to.onClose ? ctx.to.onClose($event) : null;
            })("onInput", function CalendarTypeComponent_Template_cap_calendar_onInput_0_listener($event) {
              return ctx.to.onInput ? ctx.to.onInput($event) : null;
            })("onTodayClick", function CalendarTypeComponent_Template_cap_calendar_onTodayClick_0_listener($event) {
              return ctx.to.onTodayClick ? ctx.to.onTodayClick($event) : null;
            })("onClearClick", function CalendarTypeComponent_Template_cap_calendar_onClearClick_0_listener($event) {
              return ctx.to.onClearClick ? ctx.to.onClearClick($event) : null;
            })("onMonthChange", function CalendarTypeComponent_Template_cap_calendar_onMonthChange_0_listener($event) {
              return ctx.to.onMonthChange ? ctx.to.onMonthChange($event) : null;
            })("onYearChange", function CalendarTypeComponent_Template_cap_calendar_onYearChange_0_listener($event) {
              return ctx.to.onYearChange ? ctx.to.onYearChange($event) : null;
            });
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "observablePipe");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵpipe(4, "observablePipe");
            i0.ɵɵpipe(5, "async");
            i0.ɵɵpipe(6, "observablePipe");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.to.style || null);
            i0.ɵɵproperty("formlyAttributes", ctx.field)("formControl", ctx.formControl)("floatLabel", i0.ɵɵpipeBind1(1, 54, i0.ɵɵpipeBind1(2, 56, ctx.to.label_position)) === "floating")("label", i0.ɵɵpipeBind1(3, 58, i0.ɵɵpipeBind1(4, 60, ctx.to.label_position)) === "floating" ? ctx.to.label : "")("defaultDate", ctx.to.defaultDate || null)("selectionMode", ctx.to.selectionMode || "single")("inputStyle", ctx.to.inputStyle || null)("inputId", ctx.field.key)("name", ctx.field.key)("placeholder", i0.ɵɵpipeBind1(5, 62, i0.ɵɵpipeBind1(6, 64, ctx.to.translatePlaceholder || ctx.to.placeholder)))("disabled", ctx.to.disabled)("dateFormat", ctx.to.dateFormat || "dd-mm-yy")("inline", ctx.to.inline || false)("showOtherMonths", ctx.to.showOtherMonths || true)("selectOtherMonths", ctx.to.selectOtherMonths)("showIcon", ctx.to.showIcon || true)("showOnFocus", ctx.to.showOnFocus || true)("icon", ctx.to.icon || "pi pi-calendar")("appendTo", ctx.to.appendTo || null)("readonlyInput", ctx.to.readOnlyInput || null)("shortYearCutoff", ctx.to.shortYearCutoff || "+10")("minDate", ctx.to.minDate || null)("maxDate", ctx.to.maxDate || null)("disabledDates", ctx.to.disabledDates || null)("disabledDays", ctx.to.disabledDays || null)("monthNavigator", ctx.to.monthNavigator || false)("yearNavigator", ctx.to.yearNavigator || false)("yearRange", ctx.to.yearRange || false)("showTime", ctx.to.showTime || false)("hourFormat", ctx.to.hourFormat || "24")("timeOnly", ctx.to.timeOnly || false)("dataType", ctx.to.dataType || "date")("required", ctx.to.required || false)("tabIndex", ctx.to.tabindex || null)("showSeconds", ctx.to.showSeconds)("stepHour", ctx.to.stepHour || 1)("stepMinute", ctx.to.stepMinute || 1)("stepSecond", ctx.to.stepSecond || 1)("maxDateCount", ctx.to.maxDateCount || null)("showButtonBar", ctx.to.showButtonBar || false)("todayButtonStyleClass", ctx.to.todayButtonStyleClass || "ui-secondary-button")("clearButtonStyleClass", ctx.to.clearButtonStyleClass || "ui-secondary-button")("panelStyleClass", ctx.to.panelStyleClass || null)("panelStyle", ctx.to.panelStyle || null)("keepInvalid", ctx.to.keepInvalid || false)("hideOnDateTimeSelect", ctx.to.hideOnDateTimeSelect || false)("numberOfMonths", ctx.to.numberOfMonths || 1)("view", ctx.to.view || "date")("touchUI", ctx.to.touchUI || false)("showTransitionOptions", ctx.to.showTransitionOptions || "225ms ease-out")("hideTransitionOptions", ctx.to.hideTransitionOptions || "195ms ease-in")("inputStyleClass", ctx.to.inputStyleClass || null);
          }
        },
        dependencies: [i1$6.CapturumCalendarComponent, i2.NgControlStatus, i2.RequiredValidator, i2.FormControlDirective, i3.ɵFormlyAttributes, i4.AsyncPipe, ObservablePipe],
        encapsulation: 2
      });
    }
  }
  return CalendarTypeComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ChipsTypeComponent = /*#__PURE__*/(() => {
  class ChipsTypeComponent extends FieldType {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵChipsTypeComponent_BaseFactory;
        return function ChipsTypeComponent_Factory(t) {
          return (ɵChipsTypeComponent_BaseFactory || (ɵChipsTypeComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ChipsTypeComponent)))(t || ChipsTypeComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ChipsTypeComponent,
        selectors: [["em-formly-chips"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 20,
        consts: [[3, "formlyAttributes", "field", "max", "disabled", "styleClass", "inputStyle", "placeholder", "tabindex", "inputId", "allowDuplicate", "addOnTab", "addOnBlur", "inputStyleClass", "formControl", "onAdd", "onRemove", "onChipClick", "onBlur"]],
        template: function ChipsTypeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-chips", 0);
            i0.ɵɵlistener("onAdd", function ChipsTypeComponent_Template_cap_chips_onAdd_0_listener($event) {
              return ctx.to.onAdd ? ctx.to.onAdd($event) : null;
            })("onRemove", function ChipsTypeComponent_Template_cap_chips_onRemove_0_listener($event) {
              return ctx.to.onRemove ? ctx.to.onRemove($event) : null;
            })("onChipClick", function ChipsTypeComponent_Template_cap_chips_onChipClick_0_listener($event) {
              return ctx.to.onChipClick ? ctx.to.onChipClick($event) : null;
            })("onBlur", function ChipsTypeComponent_Template_cap_chips_onBlur_0_listener($event) {
              return ctx.to.onBlur ? ctx.to.onBlur($event) : null;
            });
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "observablePipe");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.to.style || null);
            i0.ɵɵproperty("formlyAttributes", ctx.field)("field", ctx.to.field || null)("max", ctx.to.max || null)("disabled", ctx.to.disabled || false)("styleClass", ctx.to.styleClass || null)("inputStyle", ctx.to.inputStyle || null)("placeholder", i0.ɵɵpipeBind1(1, 16, i0.ɵɵpipeBind1(2, 18, ctx.to.translatePlaceholder || ctx.to.placeholder)))("tabindex", ctx.to.tabindex || null)("inputId", ctx.key)("allowDuplicate", ctx.to.allowDuplicate || true)("addOnTab", ctx.to.addOnTab || true)("addOnBlur", ctx.to.addOnBlur || false)("inputStyleClass", ctx.to.inputStyleClass || null)("formControl", ctx.formControl);
          }
        },
        dependencies: [i1$7.CapturumChipsComponent, i2.NgControlStatus, i2.FormControlDirective, i3.ɵFormlyAttributes, i4.AsyncPipe, ObservablePipe],
        encapsulation: 2
      });
    }
  }
  return ChipsTypeComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormFieldWrapper = /*#__PURE__*/(() => {
  class FormFieldWrapper extends FieldWrapper {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵFormFieldWrapper_BaseFactory;
        return function FormFieldWrapper_Factory(t) {
          return (ɵFormFieldWrapper_BaseFactory || (ɵFormFieldWrapper_BaseFactory = i0.ɵɵgetInheritedFactory(FormFieldWrapper)))(t || FormFieldWrapper);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormFieldWrapper,
        selectors: [["em-wrapper-form-field"]],
        viewQuery: function FormFieldWrapper_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7, ViewContainerRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fieldComponent = _t.first);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 6,
        vars: 5,
        consts: [[1, "form-group"], ["class", "d-block", 4, "ngIf"], ["fieldComponent", ""], ["class", "invalid-feedback", 3, "display", 4, "ngIf"], ["class", "form-text text-muted", 4, "ngIf"], [1, "d-block"], [4, "ngIf"], [1, "invalid-feedback"], [3, "field"], [1, "form-text", "text-muted"]],
        template: function FormFieldWrapper_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, FormFieldWrapper_label_1_Template, 5, 7, "label", 1);
            i0.ɵɵtemplate(2, FormFieldWrapper_ng_template_2_Template, 0, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(4, FormFieldWrapper_div_4_Template, 2, 3, "div", 3);
            i0.ɵɵtemplate(5, FormFieldWrapper_small_5_Template, 4, 5, "small", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("has-error", ctx.showError);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.to.translateLabel && ctx.to.hideLabel !== true);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.showError);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.to.description);
          }
        },
        dependencies: [i4.NgIf, i3.ɵFormlyValidationMessage, i4.AsyncPipe, ObservablePipe],
        styles: [".form-group{margin-bottom:1rem}label{display:inline-block;margin-bottom:.5rem}.has-error .ui-multiselect,.has-error .ui-dropdown,.has-error .ui-calendar,.has-error .ui-inputtext,.has-error .ui-calendar-button{border-color:#a80000}\n"],
        encapsulation: 2
      });
    }
  }
  return FormFieldWrapper;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputSwitchTypeComponent = /*#__PURE__*/(() => {
  class InputSwitchTypeComponent extends FieldType {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵInputSwitchTypeComponent_BaseFactory;
        return function InputSwitchTypeComponent_Factory(t) {
          return (ɵInputSwitchTypeComponent_BaseFactory || (ɵInputSwitchTypeComponent_BaseFactory = i0.ɵɵgetInheritedFactory(InputSwitchTypeComponent)))(t || InputSwitchTypeComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InputSwitchTypeComponent,
        selectors: [["em-input-switch-formly"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 7,
        consts: [[3, "formControl", "styleClass", "disabled", "readonly", "formlyAttributes"]],
        template: function InputSwitchTypeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cap-input-switch", 0);
          }
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.to.style || null);
            i0.ɵɵproperty("formControl", ctx.formControl)("styleClass", ctx.to.styleClass || null)("disabled", ctx.to.disabled || false)("readonly", ctx.to.readonly || false)("formlyAttributes", ctx.field);
          }
        },
        dependencies: [i1$8.CapturumInputSwitchComponent, i2.NgControlStatus, i2.FormControlDirective, i3.ɵFormlyAttributes],
        encapsulation: 2
      });
    }
  }
  return InputSwitchTypeComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ColorPickerTypeComponent = /*#__PURE__*/(() => {
  class ColorPickerTypeComponent extends FieldType {
    constructor() {
      super(...arguments);
      this.hexColorRegexp = new RegExp('^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$');
    }
    ngAfterViewInit() {
      if (this.formControl.value) {
        this.onInput({
          target: {
            value: this.formControl.value
          }
        });
      }
    }
    onInput(event) {
      if (this.hexColorRegexp.test(event.target.value)) {
        this.formControl.patchValue(event.target.value);
      }
    }
    onBlur(event) {
      if (!this.hexColorRegexp.test(event.target.value)) {
        event.target.value = this.formControl.value;
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵColorPickerTypeComponent_BaseFactory;
        return function ColorPickerTypeComponent_Factory(t) {
          return (ɵColorPickerTypeComponent_BaseFactory || (ɵColorPickerTypeComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ColorPickerTypeComponent)))(t || ColorPickerTypeComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ColorPickerTypeComponent,
        selectors: [["em-formly-color-picker"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 19,
        consts: [[3, "styleClass", "disabled", "format", "formControl", "formlyAttributes", "appendTo", "showTransitionOptions", "hideTransitionOptions", "inline", "onChange"], [1, "color-details"], ["for", "selected-color", 1, "d-block"], ["pInputText", "", "type", "text", "id", "selected-color", 1, "color-picker-input", 3, "disabled", "readOnly", "value", "blur", "input"]],
        template: function ColorPickerTypeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cap-color-picker", 0);
            i0.ɵɵlistener("onChange", function ColorPickerTypeComponent_Template_cap_color_picker_onChange_0_listener($event) {
              return ctx.to.onChange ? ctx.to.onChange($event) : null;
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(1, "div", 1)(2, "label", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "async");
            i0.ɵɵpipe(5, "observablePipe");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "input", 3);
            i0.ɵɵlistener("blur", function ColorPickerTypeComponent_Template_input_blur_6_listener($event) {
              return ctx.onBlur($event);
            })("input", function ColorPickerTypeComponent_Template_input_input_6_listener($event) {
              return ctx.onInput($event);
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.to.style || null);
            i0.ɵɵproperty("styleClass", ctx.to.styleClass || null)("disabled", ctx.to.disabled || false)("format", ctx.to.format || "hex")("formControl", ctx.formControl)("formlyAttributes", ctx.field)("appendTo", ctx.to.appendTo || null)("showTransitionOptions", ctx.to.showTransitionOptions || "225ms ease-out")("hideTransitionOptions", ctx.to.hideTransitionOptions || "195ms ease-in")("inline", !ctx.to.readOnly || ctx.to.inline && !ctx.to.readOnly);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 15, i0.ɵɵpipeBind1(5, 17, ctx.to.selectedColorLabel)) || "Geselecteerde kleur", " ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("disabled", ctx.to.disabled || false)("readOnly", ctx.to.readOnly || false)("value", ctx.formControl.value);
          }
        },
        dependencies: [i1$9.CapturumColorPickerComponent, i2.NgControlStatus, i2.FormControlDirective, i3.ɵFormlyAttributes, i4.AsyncPipe, ObservablePipe],
        encapsulation: 2
      });
    }
  }
  return ColorPickerTypeComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TextareaTypeComponent = /*#__PURE__*/(() => {
  class TextareaTypeComponent extends FieldType {
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵTextareaTypeComponent_BaseFactory;
        return function TextareaTypeComponent_Factory(t) {
          return (ɵTextareaTypeComponent_BaseFactory || (ɵTextareaTypeComponent_BaseFactory = i0.ɵɵgetInheritedFactory(TextareaTypeComponent)))(t || TextareaTypeComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TextareaTypeComponent,
        selectors: [["em-fomrly-textarea"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 21,
        consts: [[3, "formlyAttributes", "formControl", "cols", "disabled", "placeholder", "readonly", "rows", "floatLabel", "label"]],
        template: function TextareaTypeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cap-textarea", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "observablePipe");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵpipe(4, "observablePipe");
            i0.ɵɵpipe(5, "async");
            i0.ɵɵpipe(6, "observablePipe");
          }
          if (rf & 2) {
            i0.ɵɵproperty("formlyAttributes", ctx.field)("formControl", ctx.formControl)("cols", ctx.to.cols || 30)("disabled", ctx.to.disabled || false)("placeholder", i0.ɵɵpipeBind1(1, 9, i0.ɵɵpipeBind1(2, 11, ctx.to.translatePlaceholder || ctx.to.placeholder)))("readonly", ctx.to.readOnly || "")("rows", ctx.to.rows || 10)("floatLabel", i0.ɵɵpipeBind1(3, 13, i0.ɵɵpipeBind1(4, 15, ctx.to.label_position)) === "floating")("label", i0.ɵɵpipeBind1(5, 17, i0.ɵɵpipeBind1(6, 19, ctx.to.label_position)) === "floating" ? ctx.to.label : "");
          }
        },
        dependencies: [i1$a.CapturumTextareaComponent, i2.NgControlStatus, i2.FormControlDirective, i3.ɵFormlyAttributes, i4.AsyncPipe, ObservablePipe],
        encapsulation: 2
      });
    }
  }
  return TextareaTypeComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ImageTypeComponent = /*#__PURE__*/(() => {
  class ImageTypeComponent extends FieldType {
    readURL(event) {
      if (event.target.files && event.target.files[0]) {
        this.loading = true;
        const reader = new FileReader();
        reader.onload = onLoadEvent => {
          this.previewImage = reader.result;
          this.formControl.setValue(reader.result);
        };
        reader.onloadend = () => {
          this.loading = false;
        };
        reader.readAsDataURL(event.target.files[0]);
      }
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵImageTypeComponent_BaseFactory;
        return function ImageTypeComponent_Factory(t) {
          return (ɵImageTypeComponent_BaseFactory || (ɵImageTypeComponent_BaseFactory = i0.ɵɵgetInheritedFactory(ImageTypeComponent)))(t || ImageTypeComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ImageTypeComponent,
        selectors: [["em-image"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 4,
        vars: 5,
        consts: [["class", "preview-image mb-3", 4, "ngIf"], ["for", "file", 3, "class", 4, "ngIf"], ["id", "file", "type", "file", "accept", "image/*", 1, "hidden", "d-none", 3, "required", "change"], ["type", "hidden", 3, "formControl", "formlyAttributes"], [1, "preview-image", "mb-3"], ["alt", "preview", 3, "src"], ["for", "file"], [3, "class", 4, "ngIf"]],
        template: function ImageTypeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ImageTypeComponent_div_0_Template, 2, 3, "div", 0);
            i0.ɵɵtemplate(1, ImageTypeComponent_label_1_Template, 5, 8, "label", 1);
            i0.ɵɵelementStart(2, "input", 2);
            i0.ɵɵlistener("change", function ImageTypeComponent_Template_input_change_2_listener($event) {
              return ctx.readURL($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "input", 3);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.formControl.value);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", !ctx.to.readOnly);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("required", ctx.to.required);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("formControl", ctx.formControl)("formlyAttributes", ctx.field);
          }
        },
        dependencies: [i4.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.FormControlDirective, i3.ɵFormlyAttributes, i4.AsyncPipe, ObservablePipe],
        styles: [".preview-image[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:300px}"]
      });
    }
  }
  return ImageTypeComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AutocompleteDropdownComponent = /*#__PURE__*/(() => {
  class AutocompleteDropdownComponent extends FieldType {
    constructor() {
      super(...arguments);
      /**
       * Filtered results of autocomplete dropdown component
       */
      this.filteredResults = [];
    }
    /**
     * Filters results
     *
     * @param event: any
     * @param options: any[]
     * @returns void
     */
    filterResults(event, options) {
      this.filteredResults = [];
      const field = this.to.additionalProperties && this.to.additionalProperties['filterField'] ? this.to.additionalProperties['filterField'] : 'label';
      options.forEach(option => {
        if (!option[field] || option[field] === undefined) {
          return;
        }
        if (option[field].toLowerCase().indexOf(event.query.toLowerCase()) === 0) {
          this.filteredResults.push(option);
        }
      });
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵAutocompleteDropdownComponent_BaseFactory;
        return function AutocompleteDropdownComponent_Factory(t) {
          return (ɵAutocompleteDropdownComponent_BaseFactory || (ɵAutocompleteDropdownComponent_BaseFactory = i0.ɵɵgetInheritedFactory(AutocompleteDropdownComponent)))(t || AutocompleteDropdownComponent);
        };
      }();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AutocompleteDropdownComponent,
        selectors: [["em-formly-autocomplete-dropdown"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 5,
        consts: [[4, "ngIf"], [3, "suggestionsFilter", "formControl", "formlyAttributes", "field", "emptyMessage", "placeholder", "dropdown", "floatLabel", "label", "onSelect", "completeMethod"]],
        template: function AutocompleteDropdownComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, AutocompleteDropdownComponent_ng_container_0_Template, 10, 25, "ng-container", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "observablePipe");
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, i0.ɵɵpipeBind1(2, 3, ctx.to.options)));
          }
        },
        dependencies: [i4.NgIf, i2$1.CapturumAutocompleteComponent, i2.NgControlStatus, i2.FormControlDirective, i3.ɵFormlyAttributes, i4.AsyncPipe, ObservablePipe],
        encapsulation: 2
      });
    }
  }
  return AutocompleteDropdownComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormModule = /*#__PURE__*/(() => {
  class FormModule {
    static {
      this.ɵfac = function FormModule_Factory(t) {
        return new (t || FormModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FormModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, CapturumButtonModule, CapturumAutocompleteModule, CapturumInputModule, CapturumDropdownModule, CapturumMultiSelectModule, CapturumTextareaModule, CapturumColorPickerModule, CapturumInputSwitchModule, CapturumChipsModule, CapturumCalendarModule, CapturumCheckboxModule, CapturumSelectButtonModule, FormsModule, CapturumSharedModule, ReactiveFormsModule, AutoCompleteModule, FormlyModule.forChild({
          types: [{
            name: 'multiSelect',
            component: MultiSelectTypeComponent,
            wrappers: ['cap-form-field']
          }, {
            name: 'dropdown',
            component: DropdownTypeComponent,
            wrappers: ['cap-form-field']
          }, {
            name: 'selectButton',
            component: SelectButtonTypeComponent,
            wrappers: ['cap-form-field']
          }, {
            name: 'input',
            component: InputTypeComponent,
            wrappers: ['cap-form-field']
          }, {
            name: 'checkbox',
            component: CheckboxTypeComponent,
            wrappers: ['cap-form-field']
          }, {
            name: 'calendar',
            component: CalendarTypeComponent,
            wrappers: ['cap-form-field']
          }, {
            name: 'chips',
            component: ChipsTypeComponent,
            wrappers: ['cap-form-field']
          }, {
            name: 'inputSwitch',
            component: InputSwitchTypeComponent,
            wrappers: ['cap-form-field']
          }, {
            name: 'colorPicker',
            component: ColorPickerTypeComponent,
            wrappers: ['cap-form-field']
          }, {
            name: 'textarea',
            component: TextareaTypeComponent,
            wrappers: ['cap-form-field']
          }, {
            name: 'image',
            component: ImageTypeComponent,
            wrappers: ['cap-form-field']
          }, {
            name: 'autocomplete-dropdown',
            component: AutocompleteDropdownComponent,
            wrappers: ['cap-form-field']
          }],
          wrappers: [{
            name: 'cap-form-field',
            component: FormFieldWrapper
          }],
          validationMessages: [{
            name: 'required',
            message: 'This field is required'
          }]
        }), CapturumButtonModule]
      });
    }
  }
  return FormModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Formly validator for CoC number
 *
 * @param control
 */
function cocValidator(control) {
  /**
   * Standard CoC number validation regular expression
   * Must be 8 digits long
   */
  const cocRegExp = new RegExp('^[0-9]{8}$');
  return !control.value || cocRegExp.test(control.value) ? null : {
    'coc': true
  };
}

/**
 * Formly validator for e-mail address
 *
 * @param control
 */
function emailValidator(control) {
  /**
   * Standard e-mail address validation regular expression
   */
  const emailRegExp = new RegExp('[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?');
  return !control.value || emailRegExp.test(control.value) ? null : {
    'email': true
  };
}

/**
 * Formly validator for IBAN
 *
 * @param control
 */
function ibanValidator(control) {
  /**
   * Standard IBAN validation regular expression
   */
  const ibanRegExp = new RegExp('^[A-Z]{2}[0-9]{2}[A-Z0-9]{4}[0-9]{0,14}$');
  return !control.value || ibanRegExp.test(control.value) ? null : {
    'iban': true
  };
}

/**
 * Formly validator for password
 *
 * @param control
 */
function passwordValidator(control) {
  /**
   * Standard password validation regular expression
   * Length must be at least 8 characters
   */
  return !control.value || control.value.length >= 8 ? null : {
    'password': true
  };
}

/**
 * Formly validator for dutch phone or mobile phone number
 *
 * @param control
 */
function phoneValidator(control) {
  /**
   * Standard dutch phone or mobile phone regular expression
   */
  const phoneRegExp = new RegExp(/(^\+[0-9]{2}|^\+[0-9]{2}\(0\)|^\(\+[0-9]{2}\)\(0\)|^00[0-9]{2}|^0)([0-9]{9}$|[0-9\-\s]{10}$)/);
  return !control.value || phoneRegExp.test(control.value) ? null : {
    'phone': true
  };
}

/**
 * Formly validator for VAT number
 *
 * @param control
 */
function vatValidator(control) {
  /**
   * Standard vat number validation regular expression
   */
  const vatRegExp = new RegExp('(NL)?[0-9]{9}B[0-9]{2}');
  return !control.value || vatRegExp.test(control.value) ? null : {
    'vat': true
  };
}

/**
 * Formly validator for ZIP code
 *
 * @param control
 */
function zipCodeValidator(control) {
  /**
   * Standard ZIP code validation regular expression
   * Must have 1 digit between 1-9, 3 digits between 0-9 an optional whitespace and 2 letters
   */
  const zipRegExp = new RegExp('^[1-9][0-9]{3}[\\s]?[A-Za-z]{2}$');
  return !control.value || zipRegExp.test(control.value) ? null : {
    'zip': true
  };
}

/*
 * Public API Surface of form
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AutocompleteDropdownComponent, CalendarTypeComponent, CheckboxTypeComponent, ChipsTypeComponent, ColorPickerTypeComponent, DropdownTypeComponent, FormComponent, FormField, FormFieldWrapper, FormModule, FormService, FormlySelectOptionsPipe, ImageTypeComponent, InputSwitchTypeComponent, InputTypeComponent, MultiSelectTypeComponent, SelectButtonTypeComponent, TextareaTypeComponent, cocValidator, emailValidator, ibanValidator, passwordValidator, phoneValidator, vatValidator, zipCodeValidator };
